export default "__VITE_ASSET__C2osbAcs__"